<template>
    <div class="info-admin">
        <div class="title-body ps-3 py-2 mb-5">
            {{ setTitle }}
        </div>
        <div class="form-add-artist height-body mt-5 pb-3 mx-3">
            <div class="d-flex align-items-end">
                <div class="avatar avt">
                    <img class="w-100 h-100" :src="$urlImage('/images/avatar.png')"/>
                </div>
                <div class="info ps-4">
                    <p><span>Full Name:</span> {{ user.name }}</p>
                    <p><span>Email :</span> {{ user.email }}</p>
                    <!-- <button type="button" class="btn btn-success mt-4 me-2" data-bs-toggle="modal" data-bs-target="#modalInfo">Thay đổi thông tin</button> -->
                    <button type="button" class="btn btn-success mt-4 ms-2" data-bs-toggle="modal" data-bs-target="#modalPassword">Thay đổi mật khẩu</button>
                </div>
            </div>
        </div>
        <div class="modal fade modal-custom modal-edit" id="modalInfo" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <div class="modal-title text-white">Thay đổi thông tin</div>
                        <button type="button" class="btn text-white" data-bs-dismiss="modal"><i class="icon ion-md-close"></i></button>
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <div class="col-8">
                                <div>
                                    <label for="name" class="form-label mb-1">Họ và tên</label>
                                    <input type="text" class="form-control" id="name">
                                </div>
                                <div class="mt-3">
                                    <label for="email" class="form-label mb-1">Email</label>
                                    <input type="text" class="form-control" id="email">
                                </div>
                            </div>
                        </div>
                        <div class="mt-3 text-center">
                            <button type="button" class="btn btn-success">Xác nhận</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade modal-custom modal-edit" id="modalPassword" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header p-2 bg-primary">
                        <div class="modal-title text-white">Thay đổi mật khẩu</div>
                        <button type="button" class="btn text-white" data-bs-dismiss="modal"><i class="icon ion-md-close"></i></button>
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <div class="col-8">
                                <div>
                                    <label for="oldpass" class="form-label mb-1">Mật khẩu cũ</label>
                                    <input type="password" class="form-control" id="oldpass" v-model="password.old">
                                    <div class="text-error ms-1">{{ err.old }}</div>
                                </div>
                                <div class="mt-3">
                                    <label for="newpass" class="form-label mb-1">Mật khẩu mới</label>
                                    <input type="password" class="form-control" id="newpass" v-model="password.new">
                                    <div class="text-error ms-1">{{ err.new }}</div>
                                </div>
                                <div class="mt-3">
                                    <label for="confirmpass" class="form-label mb-1">Xác nhận mật khẩu</label>
                                    <input type="password" class="form-control" id="confirmpass" v-model="password.confirm">
                                    <div class="text-error ms-1">{{ err.confirm }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3 text-center">
                            <button type="button" class="btn btn-primary" @click="changePassword()">Đổi mật khẩu</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            setTitle: 'Sửa đổi thông tin',
            user: [],
            password: {
                old: '',
                new: '',
                confirm: '',
            },
            err: {
                old: '',
                new: '',
                confirm: '',
            },
        }
    },

    created() {
        document.querySelector('title').setAttribute('content', this.setTitle);
        document.querySelector('title').innerText = this.setTitle;
    },

    methods: {
        async changePassword() {
            await apiPost('/profile/change-password', {
                old_password: this.password.old,
                password: this.password.new,
                confirm_password: this.password.confirm,
            }).then(res => {
                this.logout();
            }).catch(err => {
                this.$toast.error(err.data.message, {
                    timeout: 3000,
                });
                this.err.old = err.data.old_password ? err.data.old_password[0] : '';
                this.err.new = err.data.password ? err.data.password[0] : '';
                this.err.confirm = err.data.confirm_password ? err.data.confirm_password[0] : '';
            })
        },
        async logout() {
            await apiPost('/logout',).then(res => {
                localStorage.removeItem('token');
                this.$router.push({
                    name: 'login',
                });
                location.reload();
            }).catch(err => {
                console.log(err);
            })
        }
    },

    mounted() {
        apiGet('/user').then(res => {
            this.user = res;
        }).catch(err => {
            console.log(err);
        });
    },
};
</script>

<style lang="scss">
.info-admin {
    .modal-header{
        background-color:#198754 ;
    }
    .avt {
        width: 220px;
        height: 220px;
        position: relative;
        border-radius: 4px;
        img {
            object-fit: cover;
        }

        .icon {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            position: absolute;
            font-size: 50px;
        }
    }
    .info-admin {
        width: calc(100% - 220px);
    }

    .modal-custom {
        .modal-dialog {
            margin-top: 15%;
            .modal-content {
                border: none;
                .modal-header {
                    font-size: 18px;
                    font-weight: 600;
                    border: none;
                }
            }
        }
    }
}
</style>
